'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Get if a booleanish value is true or false.
 * Booleanish is either a string or boolean (React props can sometimes allow either).
 * @param value boolean | null | string | undefined
 * @returns boolean
 */ const getBooleanishTruthy = (value)=>{
    if (value === true || value === 'true') {
        return true;
    }
    return false;
};

exports.getBooleanishTruthy = getBooleanishTruthy;
//# sourceMappingURL=booleanish.js.map
